import { render, staticRenderFns } from "./GetOriginMethods.vue?vue&type=template&id=d8f7bcb4&scoped=true&"
import script from "./GetOriginMethods.vue?vue&type=script&lang=js&"
export * from "./GetOriginMethods.vue?vue&type=script&lang=js&"
import style0 from "./GetOriginMethods.vue?vue&type=style&index=0&id=d8f7bcb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f7bcb4",
  null
  
)

export default component.exports